if($('.type-detail').length){
    if($('.extended-description .detail-parameters th:contains("Hmotnost balení")').length){
        $('.extended-description .detail-parameters th:contains("Hmotnost balení")').closest('tr').hide()
        var textAmount = $('.extended-description .detail-parameters th:contains("Hmotnost balení")').closest('tr').find('td').text()
        $('.p-final-price-wrapper .pr-list-unit').append('('+textAmount+')')
    }
    
    $(document).ready(function(){
        if($('.p-detail .flag-cena-cca').length){
            $('.availability-value').before('<div class="remark" style="width:100%;max-width:100%;font-style:italic;">'+poznamkaKcene+'</div>')
        }
    })
    
    $(document).ready(function(){
        if(zapnutiDoruceni == 1){
            $('.price-line').append('<span class="customDelivery">Možnost doručení</span>')
        }
    })
    var colorboxContent = '<div class="customDeliveryContent">'
        colorboxContent += '<h4>Možnosti doručení</h4>'
        colorboxContent += '<p>Pro zjištění možností doručení vyplňte PSČ. Následně vám sdělíme možnosti.</p>'
        colorboxContent += '<form id="validateZip"><fieldset>'
        colorboxContent += '<div class="rowLine"><label for="zip">PSČ</label>'
        colorboxContent += '<input type="text" id="zip" placeholder="např. 701 00" title="Vložte vaše PSČ"></div>'
        colorboxContent += '<div class="rowLine"><input type="submit" value="Ověřit" class="btn btn-secondary"></div>'
        colorboxContent += '</fieldset></form>'
    colorboxContent += '</div>'
    $(document).on('click', '.customDelivery', function(){
        $.colorbox({
            html: colorboxContent,
            width: 600,
            maxWidth: "95%",
            height: 500,
            maxHeight: "95%",
            className: "chooseSize",
            onComplete: function() {
                validateVat()
            },
        });
    })
    function validateVat(){
        /*$('form#validateZip').on('submit', function(e){
            e.preventDefault();
            $('.deliveryRow').remove()
            var userZip = $('#zip').val().replace(/\s/g, '');
            if (userZip.length === 5 && /^\d+$/.test(userZip)) {
                var csvData = JSON.parse(sessionStorage.getItem('csvDataCombined'));
                if (csvData) {
                    var found = csvData.find(function(row) {
                        return row.PSC === userZip; // Porovnání PSČ
                    });
                    if (found) {
                        console.log(found)
                        if(found['ID-DOPRAVY'] === ''){
                            if(found['název dodacího místa']){
                                $(this).after('<div class="deliveryRow green">V této obci prodáváme v '+found['název dodacího místa']+' na adrese '+found['ulice']+' '+found['č.p.']+', '+found['PSC']+' '+found['obec']+'.</div>')
                            }
                            $(this).after('<div class="deliveryRow alert">Litujeme, ale do Vaší oblasti nedoručujeme.</div>')
                           
                        }
                        else{
                            if(found['název dodacího místa']){
                                $(this).after('<div class="deliveryRow green">V této obci prodáváme v '+found['název dodacího místa']+' na adrese '+found['ulice']+' '+found['č.p.']+', '+found['PSC']+' '+found['obec']+'.</div>')
                            }
                            if(found['NAZEV-DOPRAVY']){
                                $(this).after('<div class="deliveryRow green">'+found['NAZEV-DOPRAVY']+'</div>')
                            }
                        //    console.log(found['název dodacího místa'])
                           
                            
                        }
                        
                       
                    } else {
                        var zipPrefix = userZip.substring(0, 2);
                        $(this).after('<div class="deliveryRow alert">Litujeme, ale do Vaší oblasti nedoručujeme.</div>')
                       
                    }
                } else {
                    // Nejsou načtená žádná data
                }
            } else {
                // Neplatné PSČ
                $(this).after('<div class="deliveryRow alert">Zadejte PSČ ve správném formátu, například 755 01.</div>')
            }
        });*/

        $('form#validateZip').on('submit', function(e) {
            e.preventDefault();
            $('.deliveryRow').remove();
            var userZip = $('#zip').val().replace(/\s/g, '');
            if (userZip.length === 5 && /^\d+$/.test(userZip)) {
                var csvData = JSON.parse(sessionStorage.getItem('csvDataCombined'));
                if (csvData) {
                    var foundRecords = csvData.filter(function(row) {
                        return row.PSC === userZip; // Porovnání PSČ
                    });
                    if (foundRecords.length > 0) {
                        var outputHtml = '';
                        var dopravaDisplayed = false;
                        foundRecords.forEach(function(found) {
                            if (found['ID-DOPRAVY'] === '') {
                                if (found['název dodacího místa']) {
                                    outputHtml += '<div class="deliveryRow places green">V této obci prodáváme v ' + found['název dodacího místa'] + ' na adrese ' + found['ulice'] + ' ' + found['č.p.'] + ', ' + found['PSC'] + ' ' + found['obec'] + '.</div>';
                                }
                                outputHtml += '<div class="deliveryRow alert">Litujeme, ale do Vaší oblasti nedoručujeme.</div>';
                            } else {
                                if (found['název dodacího místa']) {
                                    outputHtml += '<div class="deliveryRow places green">V této obci prodáváme v ' + found['název dodacího místa'] + ' na adrese ' + found['ulice'] + ' ' + found['č.p.'] + ', ' + found['PSC'] + ' ' + found['obec'] + '.</div>';
                                }
                                if (found['NAZEV-DOPRAVY'] && !dopravaDisplayed) {
                                    outputHtml += '<div class="deliveryRow green doprava">' + found['NAZEV-DOPRAVY'] + '</div>';
                                    dopravaDisplayed = true;
                                }
                            }
                        });
                        $(this).after(outputHtml);
                    } else {
                        var zipPrefix = userZip.substring(0, 2);
                        $(this).after('<div class="deliveryRow alert">Litujeme, ale do Vaší oblasti nedoručujeme.</div>');
                    }
                } else {
                    // Nejsou načtená žádná data
                }
            } else {
                // Neplatné PSČ
                $(this).after('<div class="deliveryRow alert">Zadejte PSČ ve správném formátu, například 755 01.</div>');
            }
        });

    }
}